import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeService } from "../../service/home/home.service";
import { UserResponse } from "../../auth/_models/UserResponse";

@Component({
  selector: 'app-card-info-servidor',
  templateUrl: './card-info-servidor.component.html',
  styleUrls: ['./card-info-servidor.component.sass']
})
export class CardInfoServidorComponent implements OnInit {
  user: UserResponse = null;

  constructor(private homeService: HomeService,
    private sanitizer: DomSanitizer,) { }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.getLotacaoeFoto();
  }
  private getLotacaoeFoto() {
    this.homeService.getLotacaoeFoto().subscribe(resp => {
      this.user.lotacao = resp.lotacao;
      this.user.fotoServidor = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${resp.fotoServidor}`);
    }, error => {
    })
  }

}
